const getByCountries = async (bot_id, user_id) => {
  const serverDomain = process.env.REACT_APP_SERVER;

  try {
    if (!bot_id || !user_id) {
      return {
        error: true,
        msg: "bot_id and user_id are required.",
        data: null,
      };
    }

    const params = new URLSearchParams({ bot_id, user_id });

    const url = `${serverDomain}/analysis/user-interactions-countries?${params.toString()}`;

    const response = await fetch(url);

    if (!response.ok) {
      const errorBody = await response.json();
      return {
        error: true,
        msg: errorBody.msg || "Failed to fetch data.",
        data: null,
      };
    }

    const result = await response.json();
    return {
      error: result.error ?? false,
      msg: result.msg || "Fetched interaction data successfully.",
      data: result.data,
    };
  } catch (err) {
    console.error("Error in getByCountries:", err);
    return {
      error: true,
      msg: "Something went wrong while fetching interaction data.",
      data: null,
    };
  }
};

export default getByCountries;
